import { Route, Routes, useNavigate, useParams } from 'react-router';
import { useLocation } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './App.scss';
import ContentProvider from './components/contentProvider';
import Footer from './components/footer';
import Header from './components/header';
import Layout from './components/Layout';
import ResetPassword from './components/ResetPassword';
import RaceRedirect from './components/RaceRedirect';
import PostRedirect from './components/PostRedirect';
import Home from './pages/home';
import AccountDeletion from './components/delete-account';
import ChildSafety from './components/child-safety';


function App() {
  const location = useLocation()
  const param = useParams()
  const navigate = useNavigate()
  return (
    <>
      {/* <BrowserRouter> */}
      <Routes >
        <Route path="/" element={<Header />} />
        <Route
          path="/about-us"
          element={<ContentProvider type="ABOUT_US" />}
        />
        <Route
          path="/privacy-policy"
          element={<ContentProvider type="PRIVACY_POLICY" />}
        />
        <Route
          path="/child-safety"
          element={<ChildSafety type="CHILD_SAFETY" />}
        />
        <Route
          path="/delete-account"
          element={<AccountDeletion type="ACCOUNT_DELETION" />}
        />
        <Route
          path="/terms-and-conditions"
          element={<ContentProvider type="TERM_AND_CONDITION" />}
        />
        <Route
          path="/reset-password"
          element={<ResetPassword navigate={navigate} location={location} />}
        />
        <Route
          path="/race/:raceId"
          element={<RaceRedirect />}
        />
        <Route
          path="/post/:postId"
          element={<PostRedirect />}
        />
      </Routes>
      {/* </BrowserRouter> */}
      <ToastContainer autoClose={2000} />
    </>
  )
}

export default App;
